import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Textarea, Checkbox, Group, Button, Stack, Text } from '@mantine/core';

/**
 * Modal odrzucenia pojedynczej sugestii z opcjonalnym powodem.
 * onConfirm({ reason, remember }) wywołuje rodzic (POST /dismiss/).
 */
export default function DismissReasonModal({ suggestion, onClose, onConfirm }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (suggestion) {
      setReason('');
      setRemember(true);
      setBusy(false);
    }
  }, [suggestion]);

  const submit = async () => {
    setBusy(true);
    try {
      await onConfirm({ reason: reason.trim(), remember });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      opened={!!suggestion}
      onClose={onClose}
      title={t('suggestions.dismissModal.title')}
      centered
      overlayProps={{ backgroundOpacity: 0.3, blur: 4 }}
    >
      <Stack gap="sm">
        {suggestion?.title && <Text size="sm" fw={500}>{suggestion.title}</Text>}
        <Textarea
          label={t('suggestions.dismissModal.reasonLabel')}
          placeholder={t('suggestions.dismissModal.reasonPlaceholder')}
          value={reason}
          onChange={(e) => setReason(e.currentTarget.value)}
          maxLength={500}
          minRows={3}
          autosize
          data-autofocus
        />
        <Checkbox
          size="xs"
          color="brand"
          label={t('suggestions.dismissModal.remember')}
          checked={remember}
          onChange={(e) => setRemember(e.currentTarget.checked)}
        />
        <Group justify="flex-end" gap="xs">
          <Button variant="default" size="xs" onClick={onClose} disabled={busy}>{t('suggestions.dismissModal.cancel')}</Button>
          <Button color="brand" size="xs" onClick={submit} loading={busy}>{t('suggestions.dismissModal.confirm')}</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
